function countProps(obj) {
    var count = 0;
    for (var p in obj) {
      obj.hasOwnProperty(p) && count++;
    }
    return count; 
}
// draw map
var $map_container = $("#map-container");
var map_ratio = .6;
// var state_url = "#";
var R = new ScaleRaphael("usa-map", 1000, 600);
var attr = {
        "stroke": "#fff",
        "stroke-opacity": "1",
        "stroke-linejoin": "round",
        "stroke-miterlimit": "4",
        "stroke-width": "1.2",
        "stroke-dasharray": "none",
        "cursor": 'pointer'
    };
var usRaphael = {};

//draw map and store Raphael paths
for (var state in usMap) {
//  if (window.CP.shouldStopExecution(51)) {
//        break;
//    }
//  
    // color active states purple
    if ($.inArray(state, active_states) > -1) {
        attr.fill = '#000000';
    } else {
        attr.fill = '#000000';
    }

    attr.state = state;
    usRaphael[state] = R.path(usMap[state].path).attr(attr).data("state", state);
    usRaphael['label'] = [];

    // add labels
    var pos = usRaphael[state].getBBox();

  
  for (var singlestate in state_url){
    // console.log(state_url[singlestate][0]);
    // console.log(state_url[singlestate][1]);
    if(state == state_url[singlestate][0]){
    usRaphael['label'][state_url[singlestate][0]] = R.image(state_url[singlestate][2], (pos.x + (pos.width / 2) + usMap[state].text.x) - state_url[singlestate][3], (pos.y + (pos.height / 2 + usMap[state].text.y)) - state_url[singlestate][4], 35, 35).data("state", state);
    usRaphael['label'][state_url[singlestate][0]].toFront();

      usRaphael['label'][state_url[singlestate][0]].attr({'onclick': "location.href='"+state_url[singlestate][1]+"';", 'title': state_url[singlestate][0], 'stroke-width':singlestate});
    usRaphael['label'][state_url[singlestate][0]].click(function(e) {
      
      // console.log(this[0].getAttribute('stroke-width'));
      
      // console.log(state_url[this[0].getAttribute('stroke-width')][1]);
        location.replace(state_url[this[0].getAttribute('stroke-width')][1]);
    });
    }
  }
  // for (let i = 0; i < state_url.length; i++) { 
  //   console.log(state_url[i][0]);
  //   if(state == state_url[i][0]){
  //     usRaphael['label'][state] = R.image(state_url[i][2], pos.x + (pos.width / 2) + usMap[state].text.x, pos.y + (pos.height / 2 + usMap[state].text.y), 35, 35).data("state", state);
  //     usRaphael['label'][state].toFront();
  //   }
  // }
  
// console.log(state_url);
// console.log(countProps(state_url));
  
    if ($.inArray(state, active_states) > -1) {
    // usRaphael['label'][state] = R.image(state_icon[state], pos.x + (pos.width / 2) + usMap[state].text.x, pos.y + (pos.height / 2 + usMap[state].text.y), 35, 35).data("state", state);
    // usRaphael['label'][state] = R.image(state_icon[state], (pos.x + (pos.width / 2) + usMap[state].text.x) - 25, pos.y + (pos.height / 2 + usMap[state].text.y), 35, 35).data("state", state);
    }else{
        usRaphael['label'][state] = R.circle(10, 10, 0).data("state", state);
    }
  
    usRaphael['label'][state].toFront();

    // active states hover to light purple
    if ($.inArray(state, active_states) > -1) {
        usRaphael[state].hover(function() {
            this.animate({
                fill: "#A1C0F6"
            }, 500);
        }, function() {
            this.animate({
                fill: "#000"
            }, 500);
        });
        // usRaphael['label'][state].hover(function() {
        //     this.prev.animate({
        //         fill: "#A1C0F6"
        //     }, 500);
        // }, function() {
        //     this.prev.animate({
        //         fill: "#000"
        //     }, 500);
        // });
    } else {
        usRaphael[state].hover(function() {
            this.animate({
                fill: "#000"
            }, 500);
        }, function() {
            this.animate({
                fill: "#000"
            }, 500);
        });
        // usRaphael['label'][state].hover(function() {
        //     this.prev.animate({
        //         fill: "#000"
        //     }, 500);
        // }, function() {
        //     this.prev.animate({
        //         fill: "#000"
        //     }, 500);
        // });
    }

    // bind click
  if(state_url[state]){
    // usRaphael[state].click(function() {
    //   // console.log(this.data("state"));
    //   // console.log(state_url[this.data("state")]);
    //     location.replace(state_url[this.data("state")]);
    // });
    // usRaphael['label'][state].click(function() {
    //   // console.log(this.data("state"));
    //   // console.log(state_url[this.data("state")]);
    //     location.replace(state_url[this.data("state")]);
    // });
  }
    if (typeof usMap[state].text.hide !== 'undefined' && usMap[state].text.hide === true)
        usRaphael['label'][state].remove();
}

R.changeSize($map_container.width(), $map_container.width() * map_ratio);

$(window).resize(function() {
    R.changeSize($map_container.width(), $map_container.width() * map_ratio);
});